"use client";

import React from "react";

export interface TherapistSearchHeaderProps {
  resultCount: number;
  showCount: boolean;
  onOpenMobileFilters?: () => void;
  /** Destination for the "Take our matching quiz" CTA. Defaults to `/quiz`
   *  (employee + client apps use that route). imwell points it at
   *  `/dashboard/therapy/match`. */
  quizHref?: string;
}

export function TherapistSearchHeader({
  resultCount,
  showCount,
  onOpenMobileFilters,
  quizHref = "/quiz",
}: TherapistSearchHeaderProps) {
  return (
    <div className="max-w-7xl mx-auto px-4 pt-8 pb-6">
      <div className="text-center mb-8">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Find your therapist
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Browse therapists or let us help you find the perfect match.
        </p>
        <div className="mt-6 inline-flex items-center gap-2 bg-gradient-to-r from-primary-50 to-secondary-50 px-6 py-3 rounded-full">
          <span className="text-gray-700">Not sure where to start?</span>
          <a
            href={quizHref}
            className="text-primary-600 hover:text-primary-700 font-medium underline decoration-dotted underline-offset-2"
          >
            Take our 2-minute matching quiz
          </a>
        </div>
      </div>
      
      {/* Mobile filter button and results count */}
      <div className="flex items-center justify-between md:justify-start gap-4">
        <button 
          onClick={onOpenMobileFilters}
          className="md:hidden flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-gray-700 font-medium"
        >
          <svg className="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
          <span>Filters</span>
        </button>
        
        {showCount && (
          <p className="text-sm text-gray-600">
            {resultCount} {resultCount === 1 ? 'therapist' : 'therapists'} found
          </p>
        )}
      </div>
    </div>
  );
}